import { render } from "./Home.vue?vue&type=template&id=798043da"
import script from "./Home.modal.js?vue&type=script&lang=js"
export * from "./Home.modal.js?vue&type=script&lang=js"

import exportComponent from "/Users/danilomeulens/Projects/_sandbox/simpsonbay_geneology/source/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__